module.exports = __webpack_public_path__ + "static/siderail3-9452dc605d0158c02271d3859b2ec2a5.jpg";